<template>
  <div>
    <el-row id="content-title">
      <el-col :span="24">
        <div class="d-flex align-items-center">
          <h3 class="mb-0">Stock Request</h3>
          <div class="ml-auto">
            <router-link
              class="el-button el-button--primary el-button--mini"
              :to="{ name: 'request_info' }"
              title="Create new stock request"
              ><i class="el-icon-magic-stick"></i> New</router-link
            >
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <router-view :key="$route.fullPath"></router-view>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "stockrequest",

  data() {
    return {};
  }
};
</script>

<style lang="css" scoped></style>
